import { render } from "./BetConfirmation.vue?vue&type=template&id=7931ad52&scoped=true"
import script from "./BetConfirmation.vue?vue&type=script&lang=js"
export * from "./BetConfirmation.vue?vue&type=script&lang=js"

import "@/assets/scss/ticket/betConfirmation.scss?vue&type=style&index=0&id=7931ad52&scoped=true&lang=scss"

import exportComponent from "/Users/thanhnguyen/Desktop/ThanhNguyen/projects/public_html/numbers-betting-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7931ad52"]])

export default __exports__